import Location from './location'
import User from './user'


// This class initializes the logic for managing vehicle data
/**
 * @author -- Peter Collins /github.com/chimdipetercollins
 */

class Vehicle {
    /**
     * @param   color: String 
     */
    constructor(object) {
        if (object) {
            this._color = object.color
            this._dailyFee = object.dailyFee
            this._description = object.description
            this._driverFee = object.driverFee
            this._hasDriver = object.hasDriver
            this._images = []
            this._make = object.make
            this._model = object.model
            this._modelYear = object.modelYear
            this._registration = object.registration
            this._timestamp = object.timestamp
            this._type = !object.type ? 'all' : object.type 
            this._vehicleClass = !object.vehicleClass ? 'all' : object.vehicleClass
        }

        this._location = new Location()
        this._leaser = new User()

        this._typeof = 'vehicle'
    }

    // getters

    get color() {
        return this._color
    }

    get dailyFee() {
        return this._dailyFee
    }

    get description() {
        return this._description
    }

    get driverFee() {
        return this._driverFee
    }

    get hasDriver() {
        return this._hasDriver
    }

    get id() {
        return this.name + this.timestamp
    }

    get images() {
        return this._images
    }

    get make() {
        return this._make
    }

    get model() {
        return this._model
    }

    get modelYear() {
        return this._modelYear
    }

    get name() {
        return this._make + ' ' + this._model + ' ' + this._modelYear
    }

    get registration() {
        return this._registration
    }

    get timestamp() {
        return this._timestamp
    }

    get type() {
        return this._type
    }

    get vehicleClass() {
        return this._vehicleClass
    }

    get location() {
        let value

        this._location.typeof === 'location'
        ?   value = this._location
        :   value = 'invalid'

        return value
    }

    get leaser() {
        let value

        this._leaser.typeof === 'instarent user'
        ?   value = this._leaser
        :   value = 'invalid'
        
        return value
    }

    get typeof() {
        return this._typeof
    }

    // setters

    /**
     * @param {String} value
     */
    set setColor(value) {
        this._color = value
    }

    /**
     * @param {String} value
     */
    set setDailyFee(value) {
        this._dailyFee = value
    }

    /**
     * @param {String} value
     */
    set setDescription(value) {
        this._description = value
    }

    /**
     * @param {String} value
     */
    set setDriverFee(value) {
        this._driverFee = value
    }

    /**
     * @param {String} value
     */
    set setDriver(value) {
        this._hasDriver = value
    }

    /**
     * @param {String} value
     */
    set addImage(value) {
        this.images.length <= 3
        ?   this._images.push(value)
        :   this.images[0] = value
    }

    /**
     * @param {String} value
     */
    set setMake(value) {
        this._make = value
    }

    /**
     * @param {String} value
     */
    set setModel(value) {
        this._model = value
    }

    /**
     * @param {String} value
     */
    set setModelYear(value) {
        this._modelYear = value
    }

    /**
     * @param {String} value
     */
    set setRegistration(value) {
        this._registration = value
    }

    /**
     * @param {String} value
     */
    set setTimestamp(value) {
        this._timestamp = value
    }

    /**
     * @param {String} value
     */
    set setType(value) {
        this._type = value
    }

    /**
     * @param {String} value
     */
    set setClass(value) {
        this._vehicleClass = value
    }

    /**
     * @param {String} value
     */
    set setLocation(value) {
        this._location = value
    }

    /**
     * @param {String} value
     */
    set setLeaser(value) {
        this._leaser = value
    }
}

export default Vehicle
